import { Icons, ToggleButton, ToggleButtonGroup } from '@cast/design-system';

type ToggleValue = 'allowed' | 'denied' | 'none';

export const boolToToggleValue = (val?: boolean): ToggleValue => {
  if (val) {
    return 'allowed';
  }
  if (val === undefined) {
    return 'none';
  }
  return 'denied';
};

type ToggleProps = {
  value: ToggleValue;
  onChange: (value: ToggleValue) => void;
  disabled?: boolean;
};

export const Toggles = ({ value, onChange, disabled }: ToggleProps) => {
  return (
    <ToggleButtonGroup
      value={value}
      onChange={(_, value) => {
        onChange(value as ToggleValue);
      }}
      size="sm"
      disabled={disabled}
    >
      <ToggleButton
        value="allowed"
        icon={
          <Icons.CheckCircle
            color={value === 'allowed' ? 'green' : undefined}
          />
        }
      />
      <ToggleButton
        value="denied"
        icon={<Icons.XCircle color={value === 'denied' ? 'red' : undefined} />}
      />
      <ToggleButton value="none" icon={<Icons.MinusCircle />} />
    </ToggleButtonGroup>
  );
};
